import React from 'react';
import { tv } from 'tailwind-variants';
import useFlags from '@/hooks/useFlags';
import LessonSubheader from '@/components/shared/NewLessonOverview/LessonSubheader';
import { SlideGroup } from '@/types/api/LessonOverview';
import SlideGroupCard from './Cards/Card/SlideGroupCard';

interface SlideGroupSectionProps {
  slideGroups: SlideGroup[];
  subheaderNumber?: number;
  title: string;
}

const sectionStyles = tv({
  base: '',
  variants: {
    reflow: {
      false: 'tw-mr-20',
      true: 'tw-mr-0',
    },
  },
});

const SlideGroupSection = ({ slideGroups, subheaderNumber, title }: SlideGroupSectionProps) => {
  const { accessibilityReflow } = useFlags();

  return (
    <LessonSubheader
      subheaderNumber={subheaderNumber}
      title={title}
    >
      <section className={sectionStyles({ reflow: accessibilityReflow })}>
        {slideGroups.map(slideGroup => (
          <SlideGroupCard
            key={slideGroup.id}
            slideGroup={slideGroup}
          />
        ))}
      </section>
    </LessonSubheader>
  );
};

export default SlideGroupSection;
